import { RefObject, useEffect, useState } from 'react';

export const useGetFreeSizesSpace = <T extends HTMLElement>(
  firstElem: RefObject<T>,
  secondElem: RefObject<T>
) => {
  const [freeSpaceHeight, setFreeSpaceHeight] = useState(0);
  const [freeSpaceWidth, setFreeSpaceWidth] = useState(0);

  useEffect(() => {
    const parentContainerHeight = firstElem.current?.offsetHeight;
    const headContainerHeight = secondElem.current?.offsetHeight;
    const parentContainerWidth = firstElem.current?.offsetWidth;
    const headContainerWidth = secondElem.current?.offsetWidth;

    if (parentContainerHeight && headContainerHeight) {
      setFreeSpaceHeight(parentContainerHeight - headContainerHeight);
    }

    if (parentContainerWidth && headContainerWidth) {
      setFreeSpaceWidth(parentContainerWidth - headContainerWidth);
    }
  }, [firstElem, secondElem]);

  return { freeSpaceHeight, freeSpaceWidth };
};
